'use client';

import { StructuredContentProvider } from '@nerdwallet/structured-content-core';

import { client } from '~/app/lib/structured-content/structured-content';

import StoreProvider from '~/app/lib/redux/StoreProvider';
import { AnalyticsWrapper } from '~/app/lib/analytics-wrapper';
import { MediaQueryProvider } from '~/app/lib/use-media-query';
import { useInitializeGtm } from '~/app/lib/initialize-gtm';

type FlatOutline = {
  [key: string]: object;
};

export type PreloadedState = {
  identity: {
    isSignedIn: boolean;
    current: CurrentRolesType;
  };
  builder: {
    flatOutline: FlatOutline;
    dynamicGrid: {
      marketplaceOffers: { [key: string]: unknown[] } | unknown[];
      pressReleases: { [key: string]: unknown[] } | unknown[];
    };
    editor: {
      showAllMediaViewPorts: boolean;
    };
  };
};

export interface CurrentRolesType {
  roles: string[];
}

interface ConfigPageProps {
  children: React.ReactNode;
  preloadedState: PreloadedState;
  deviceType: string;
  pageTaxonomy: { nwVarName: string; bkVarName: string; value: any }[];
}

export default function ConfigPage({
  children,
  preloadedState,
  deviceType,
  pageTaxonomy,
}: ConfigPageProps) {
  useInitializeGtm({ pageTaxonomy });
  return (
    <AnalyticsWrapper preloadedState={preloadedState}>
      <MediaQueryProvider deviceType={deviceType}>
        <StoreProvider preloadedState={preloadedState}>
          <StructuredContentProvider client={client}>
            {children}
          </StructuredContentProvider>
        </StoreProvider>
      </MediaQueryProvider>
    </AnalyticsWrapper>
  );
}
